import { useCallback } from 'react';

import { type UploadAnalyticsSource, useTrackUploadConcurrencyChanged } from '@air/analytics';
import { type UploadConcurrencyChangeParams } from '@air/upload-manager';
import { reportErrorToBugsnag } from '@air/utils-error';

export const useUploadConcurrencyChangeAnalytics = ({ source }: { source: UploadAnalyticsSource }) => {
  const { trackUploadConcurrencyChanged } = useTrackUploadConcurrencyChanged();

  const onConcurrencyChange = useCallback(
    (params: UploadConcurrencyChangeParams) => {
      try {
        trackUploadConcurrencyChanged({
          active_workers: params.active_workers,
          change_reason: params.change_reason,
          concurrency_budget_bytes: params.concurrency_budget_bytes,
          concurrency_mode: params.concurrency_mode,
          from_workers: params.from_workers,
          in_flight_bytes: params.in_flight_bytes,
          source,
          to_workers: params.to_workers,
          upload_speed_bytes_per_second: params.upload_speed_bytes_per_second ?? undefined,
        });
      } catch (analyticsError) {
        reportErrorToBugsnag({
          context: 'Failed to track upload concurrency changed analytics',
          error: analyticsError,
        });
      }
    },
    [source, trackUploadConcurrencyChanged],
  );

  return { onConcurrencyChange };
};
